module.exports = __webpack_public_path__ + "media/customizations/trinityfalls/logo-6aa242b7d07005d3de18d9f94d4e72c0.png";